import React from "react";
import PropTypes from "prop-types";
import GonkBoundary from "views/GonkBoundary";

export class ModalLayout extends React.Component {

    constructor(props) {
        super(props);
        this.resizeBodyRef = this.resizeBodyRef.bind(this);
    }

    render() {
        const {
            modalOptions = {},
            size,
            children,
            triggerClose,
            moduleRef,
        } = this.props;
        let {
            title,
        } = this.props;
        if (title == null) title = modalOptions.title;
        const sizeClass = size == null
            ? modalOptions.size || "modal-xlg"
            : "modal-" + size;

        let body;

        if (children != null) {
            body = <GonkBoundary>
                <div className="modal-body"
                     ref={this.resizeBodyRef}
                >
                    {children}
                </div>
            </GonkBoundary>;
        } else {
            body = <GonkBoundary>
                <div className="modal-body"
                     ref={n => {
                         if (n == null) return; // not mounted anymore...
                         this.resizeBodyRef(n, true);
                         // This allows a modal coming back to the top of the
                         // stack to dispatch during (re)initialization, even if
                         // the stack pop was triggered by a dispatch.
                         //
                         // eslint-disable-next-line no-settimeout
                         setTimeout(() => {
                             moduleRef.render();
                             $(n).html(moduleRef.el);
                             moduleRef.onDomRefresh();
                         });
                     }}
                >
                </div>
            </GonkBoundary>;
        }

        return (
            <div className="modal">
                <div className={"modal-dialog " + sizeClass}>
                    <div className="modal-content">
                        <div className="modal-header"
                             ref="header">
                            <button type="button" onClick={triggerClose} className="modal-close">
                                <span aria-hidden="true"/>
                                <span className="sr-only">Close</span>
                            </button>
                            <div className="modal-title">{title}</div>
                        </div>
                        {body}
                    </div>
                </div>
            </div>
        );
    }

    resizeBodyRef(node, defaultBehaviour = false) {
        let {
            resizeBodyOnRender,
        } = this.props;
        if (resizeBodyOnRender == null) {
           resizeBodyOnRender = defaultBehaviour;
        }
        if (!resizeBodyOnRender) return;
        // An element needs to be visible
        // in order to read its dimensions
        const el = $(this.refs.header).clone().css("display", "none");
        $("body").append(el);
        const height = el.height();
        el.remove();

        $(node).css({
            position: "absolute",
            top: height + "px",
            bottom: "0px",
        });
    }
}

ModalLayout.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
    ]),
    moduleRef: PropTypes.object,
    modalOptions: PropTypes.shape({
        // these are ignored if the top-level props are set
        title: PropTypes.string,
        size: PropTypes.string, // an arbitrary CSS class (or classes)
    }),
    title: PropTypes.string,
    size: PropTypes.string, // one of the bootstrap sizes: sm, md, lg, xlg
    triggerClose: PropTypes.func.isRequired,
    resizeBodyOnRender: PropTypes.bool, // default true for BB modules, false otherwise
};



// WEBPACK FOOTER //
// ./app/lib/modal/ModalLayout.js